import * as React from 'react';

function RateAdvanced(props) {
  return (
    <svg width={40} height={56} fill="none" {...props}>
      <rect
        width={40}
        height={56}
        rx={4}
        fill="url(#prefix__paint0_linear_1008_1318)"
      />
      <path d="M26 18a6 6 0 11-12 0 6 6 0 0112 0z" fill="#3E0C9D" />
      <path
        d="M12 18h16"
        stroke="#EDE9FE"
        strokeWidth={1.25}
        strokeMiterlimit={10}
      />
      <path
        d="M22 18c0 3.314-.895 6-2 6s-2-2.686-2-6 .895-6 2-6 2 2.686 2 6z"
        stroke="#ECE8FE"
        strokeWidth={1.25}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M22.192 9.271A9 9 0 1029 18.092"
        stroke="#3E0C9D"
        strokeWidth={1.615}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        opacity={0.5}
        d="M7 36h26M7 42h26M7 48h26"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={22}
        y={4}
        width={13}
        height={13}
      >
        <path fill="#D9D9D9" d="M22 4h13v13H22z" />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M28.5 10.5c.298 0 .553-.106.765-.318.213-.212.319-.467.319-.765s-.106-.553-.319-.765a1.043 1.043 0 00-.765-.318c-.298 0-.553.106-.765.318a1.043 1.043 0 00-.318.765c0 .298.106.553.318.765.212.212.467.318.765.318zm0 5.417c-1.453-1.237-2.539-2.386-3.256-3.447-.718-1.06-1.077-2.042-1.077-2.945 0-1.354.436-2.433 1.307-3.236.87-.804 1.88-1.205 3.026-1.205 1.147 0 2.156.401 3.027 1.205.871.803 1.307 1.882 1.307 3.236 0 .903-.36 1.885-1.077 2.945-.718 1.061-1.803 2.21-3.257 3.447z"
          fill="#3E0C9D"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__paint0_linear_1008_1318"
          x1={20}
          y1={0}
          x2={20}
          y2={56}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F0FF" />
          <stop offset={1} stopColor="#E4DEFC" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const MemoRateAdvanced = React.memo(RateAdvanced);
export default MemoRateAdvanced;
